module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00070.2df99694.jpg";